import { render } from "./Notification.vue?vue&type=template&id=5a9a2286&scoped=true"
import script from "./Notification.vue?vue&type=script&lang=js"
export * from "./Notification.vue?vue&type=script&lang=js"

import "./Notification.vue?vue&type=style&index=0&id=5a9a2286&lang=scss&scoped=true"

import exportComponent from "/builds/common/delivery-front/dev-factory/supplyweb/opticam/packages/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a9a2286"]])

export default __exports__